/*
 * @Author: Gary
 * @Date: 2017-09-06 17:23:33
 * @Last Modified by: Gary
 * @Last Modified time: 2018-03-02 11:38:13
 * 封装axios
 */
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import store from '../store';
import { getToken } from '@/utils/auth';
// import qs from 'qs';


// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 80000,                  // 请求超时时间
  // transformRequest: obj => qs.stringify(obj),
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});

// request拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['X-Auth-Token'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // config.headers['Content-Type'] = 'application/json';
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code === 200 || response.status === 200) {
      return response.data;
    } else {
      // 51005=冻结
      Message({
        message: response.data.message,
        type: 'error'
      });
      return Promise.reject(response);
    }
  },
  error => {
    console.dir(error);// for debug
    if (error.response) {
      Message({
        message: error.response.data.message,
        type: 'error'
      });
    } else {
      let msg = '服务器请求出错';
      if (error.message.indexOf('timeout') !== -1) {
        msg = '请求超时';
      } else if (error.message.indexOf('Network Error') !== -1) {
        msg = '网络出错';
      }
      Message({
        message: msg,
        type: 'error'
      });
    }
    return Promise.reject(error);
  }
)

service.postJson = (path, params) => service({
  url: path,
  method: 'post',
  data: params,
  transformRequest: obj => JSON.stringify(obj),
  headers: { 'Content-Type': 'application/json' }
})

service.getJson = (path, params) => service({
  url: path,
  method: 'get',
  params,
  transformRequest: obj => JSON.stringify(obj),
  headers: { 'Content-Type': 'application/json' }
})

service.deleteJson = (path, params) => service({
  url: path,
  method: 'delete',
  params,
  transformRequest: obj => JSON.stringify(obj),
  headers: { 'Content-Type': 'application/json' }
})

service.putJson = (path, data) => service({
  url: path,
  method: 'put',
  data,
  transformRequest: obj => JSON.stringify(obj),
  headers: { 'Content-Type': 'application/json' }
})

service.postFrom = (path, data) => service({
  url: path,
  method: 'post',
  data,
  headers: { 'content-type': 'application/x-www-form-urlencoded' }
})

//this.axios.postFrom("/index.php?ctl=tool&act=get_pkey",forms)

export default service;



// WEBPACK FOOTER //
// ./src/utils/axios.js